import NpsByHourOfDayWidget from './NpsByHourOfDayWidget';
export default NpsByHourOfDayWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/NpsByHourOfDayWidget/index.js